/**
 * get websocket url based on environment
 */
export function getWebSocketUrl(): string {
  if (process.env.NODE_ENV === "development") {
    return "ws://localhost:5000/socket";
  }

  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  return `${protocol}//${window.location.host}/socket`;
}
